import { useI18n } from 'vue-i18n';
import eventBus from '@/setup/eventBus';

export function useCopy() {
  const { t } = useI18n();

  const copy = async(
    content: string,
    success?: string,
    error?: string
  ) => {
    const successText = success || t('reports.other.copied_to_clipboard');
    const errorText = error || t('reports.other.failed_to_copy');

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(content)
      } else {
        const textarea = document.createElement('textarea')
        textarea.value = content

        textarea.style.position = 'absolute'
        textarea.style.left = '-9999px'
        textarea.style.opacity = '0'
        textarea.readOnly = true
        textarea.contentEditable = 'true'

        document.body.appendChild(textarea)
        textarea.select()
        textarea.setSelectionRange(0, 99999)

        const copied = document.execCommand('copy')
        textarea.remove()

        if (!copied) {
          throw new Error('document.execCommand("copy") failed')
        }
      }

      eventBus.$emit('notify-event', {
        type: 'info',
        text: successText,
      });
    } catch (error) {
      eventBus.$emit('notify-event', {
        type: 'error',
        text: errorText,
      });
    }
  };

  return { copy };
}
